export default __webpack_public_path__ + "static/media/project2.e4c9cefb.webp";